module.exports = __webpack_public_path__ + "assets/img/vip_icon.15a12a3f.png";